<template>
    <div
        class="patsnap-biz-avatar"
        :style="{
            backgroundImage: `url(${avatar})`,
            backgroundSize: 'contain',
            backgroundColor
        }"
    >
        <span v-if="!done && !error && name">{{ name }}</span>
        <PtIcon
            v-if="error || noAvatar"
            class="patsnap-biz-avatar__error"
            icon="SolidProfile"
        />
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
// eslint-disable-next-line max-len
// 设计稿：https://lanhuapp.com/web/#/item/project/detailDetach?type=share_mark&pid=a5627033-053c-4530-8dab-538f8e2ddf7d&imgId=02334554-cac7-4a10-a51d-069154de5601&project_id=a5627033-053c-4530-8dab-538f8e2ddf7d&image_id=02334554-cac7-4a10-a51d-069154de5601&teamId=5e4872c5-7dfc-495c-abe9-2e4a95564714&userId=230b5933-3ab9-4f35-87d1-9ab2b79d0713&param=9ad96264-4479-4afd-b178-176d19dcef29
export default {
    name: 'PtAvatar',
    components: {
        PtIcon,
    },
    props: {
        /**
         * 用户名称
         */
        username: {
            type: String,
            default: '',
        },
        /**
         * 用户头像地址
         */
        avatar: {
            type: String,
            default: '',
        },
        /**
         * 头像背景颜色
         */
        avatarColor: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            done: false,
            error: false,
        };
    },
    computed: {
        name() {
            return this.username.substring(0, 1).toUpperCase();
        },
        backgroundColor() {
            if (!this.avatarColor) return '#F4F5F7';
            return `#${Number(this.avatarColor).toString(16)}`;
        },
        noAvatar() {
            return !this.name && !this.avatar;
        },
    },
    watch: {
        avatar: {
            handler() {
                this.loadAvatar();
            },
            immediate: true,
        },
    },
    methods: {
        loadAvatar() {
            const vm = this;
            vm.done = false;
            vm.error = false;
            if (!this.avatar) {
                return;
            }
            const img = new Image();
            img.onload = () => {
                vm.done = true;
            };
            img.onerror = () => {
                vm.error = true;
            };
            img.src = this.avatar;
        },
    },
};
</script>
